import {AfterContentInit, Component, ContentChild, ElementRef, HostListener, Input} from '@angular/core';
import {RouterLinkActive} from '@angular/router';

@Component({
    selector: 'app-dropdown-navbar',
    template: `
    <div *ngIf="active" class="dropdown my-0 pt-0 pb-0 d-inline">
      <button
        class="btn btn-navbar py-0"
        [ngClass]="{ 'active': isActive()}"
        (click)="onDropdownClick()"
      >

        <i *ngIf="fa" class="fa fa-{{ fa }} pr-1 d-inline-block" aria-hidden="true"></i>

        <span class="d-none d-sm-inline" *ngIf="user">{{ user.username }}</span>

        <div class="d-none d-sm-inline"> {{ getTitle() | translate }} </div>
        <!--<i class="fa fa-caret-down" aria-hidden="true"></i> -->

      </button>

      <ul class="dropdown-menu dropdown-menu-navbar-cnr"
           [ngClass]="{'invisible': !opened, 'dropdown-menu-right': rightAlignment}"
           [ngStyle]="{'min-width': width}">
        <ng-content></ng-content>
      </ul>
    </div>

  `,
    standalone: false
})
export class DropdownNavbarComponent implements AfterContentInit {

  @Input() width = '10rem';

  @Input() active = true;
  @Input() dropdownTitle;
  @Input() rightAlignment;
  @Input() user;

  @Input() fa;

  opened = false;

  @ContentChild('rla', {static: true}) rla: RouterLinkActive;

  @HostListener('document:click', ['$event', '$event.target'])
  onClick(event: any, targetElement: any): void {
    if (!targetElement) {
      return;
    }
    // console.log(targetElement);
    // console.log(this._eref.nativeElement);
    // console.log(targetElement.hasAttribute('href'));
    const clickedInside = this._eref.nativeElement.contains(targetElement);
    const clickRouting = targetElement.hasAttribute('href');
    if (!clickedInside || clickRouting) {
      this.opened = false;
    }
  }

  constructor(private _eref: ElementRef) {}

  getTitle() {
    if (this.user) {
      return this.user.fullname;
    }
    return this.dropdownTitle;
  }

  isActive() {
    return (this.rla && this.rla.isActive) || this.opened;
  }

  ngAfterContentInit() {
  }

  onDropdownClick() {
    console.log('onDropdownClick');
    this.opened = !this.opened;
  }
}
